<template>
  <VLayout column>
    <Header/>
    <ErrorPage :message="message" status="500"/>
    <Footer/>
  </VLayout>
</template>
<script>
// @ is an alias to /src
import Header from '@/components/Header.vue';
import ErrorPage from '@/components/ErrorPage.vue';

export default {
  name: 'NotFound',
  components: {
    Header,
    ErrorPage,
  },
  data: () => ({
    message: 'Ha surgido un error al cargar la información del link de pago. Por favor vuelve a intentarlo.',
  }),
};
</script>
